import { render, staticRenderFns } from "./df-ssc.vue?vue&type=template&id=570637d4"
import script from "./df-ssc.vue?vue&type=script&lang=js"
export * from "./df-ssc.vue?vue&type=script&lang=js"
import style0 from "./df-ssc.vue?vue&type=style&index=0&id=570637d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports